import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"

interface SizeProps {
  size: number
}

interface PictureWrapperProps {
  index: number
}

export const InnerWrapper = styled.div<SizeProps>`
  position: relative;
  min-width: ${(props) => props.size}px;
  height: 50px;
`

export const PicturesWrapper = styled.div<PictureWrapperProps>`
  position: absolute;
  left: ${(props) => props.index * 20}px;
  border: ${({theme}) =>  `3px solid ${theme.colors.utility.white}`};
  border-radius: 50%;
  background-color: ${({theme}) => theme.colors.utility.white};
`

export const RemainingCountNumber = styled(Flex)<SizeProps>`
${({theme, size}) => css`
    height: ${size}px;
    width: ${size}px;
    border-radius: 100%;
    background-color: ${theme.colors.perkbox.blue};
  `}
`

export const Image = styled.img`
  border-radius: 50%;
`
